<script lang="ts" setup>
import BaseHoverDropdown from '@/components/BaseHoverDropdown.vue';

const LanguageMenuList = defineAsyncComponent(
  () => import('@/components/LanguageMenuList.vue'),
);

const props = withDefaults(
  defineProps<{
    position?: 'top' | 'bottom';
    isShowIcon?: boolean;
  }>(),
  {
    position: 'bottom',
    isShowIcon: false,
  },
);

const { activeLang } = useLocales();
</script>

<template>
  <base-hover-dropdown
    :class="['languages', `languages--${props.position}`]"
    position="bottom"
  >
    <template #trigger>
      <span class="languages__btn text-body-s text-weight-medium">
        <img
          v-if="props.isShowIcon"
          width="16"
          height="16"
          :src="activeLang.iconLink"
          :alt="activeLang.label"
        />
        {{ activeLang.value }}
      </span>
    </template>

    <template #default="{ firstOpen }">
      <LanguageMenuList
        v-if="firstOpen"
        class="languages__list"
      />
    </template>
  </base-hover-dropdown>
</template>

<style lang="scss" scoped>
.languages {
  $this: 'languages';

  line-height: normal;

  :deep(.hover-dropdown__inner) {
    overflow: hidden;
    border-radius: $brd-12;
  }

  :deep(.hover-dropdown__icon) {
    color: $color-dark-blue-500;
    margin-left: 2px;
  }

  :deep(.hover-dropdown__wrap) {
    z-index: 3001;
    left: auto;
    right: 0;

    @include media-down('md') {
      padding-top: 8px;
    }
  }

  &--top {
    :deep(.hover-dropdown__wrap) {
      top: 16px;
      left: -24px;
      right: auto;
    }
  }

  &__btn {
    @include reset-btn;

    text-transform: uppercase;
    display: flex;
    align-items: center;
    column-gap: 5px;
    padding-right: 2px;
    color: $color-dark-blue-500;
    font-weight: 500;
  }

  &__list {
    min-width: 140px;
    max-height: 80vh;
    overflow: auto;
  }
}

[dir='rtl'] {
  .languages {
    :deep(.hover-dropdown__wrap) {
      z-index: 3001;
      left: 0;
      right: auto;
    }
  }
}
</style>
